// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_contentContainer__fAXaI {
  min-height: 36vh;
  width: 90vw; }
  .styles_contentContainer__fAXaI > div {
    max-width: 90%;
    margin: 1.5rem auto; }
    .styles_contentContainer__fAXaI > div p {
      text-align: justify;
      font-size: 1.5rem; }
    .styles_contentContainer__fAXaI > div h2 {
      font-size: 2rem;
      text-align: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/Dialog/components/MobileModal/styles.module.scss"],"names":[],"mappings":"AAAA;EACI,gBAAgB;EAChB,WAAW,EAAA;EAFf;IAKQ,cAAc;IACd,mBAAmB,EAAA;IAN3B;MAQY,mBAAmB;MACnB,iBAAiB,EAAA;IAT7B;MAaY,eAAe;MACf,kBAAkB,EAAA","sourcesContent":[".contentContainer {\n    min-height: 36vh;\n    width: 90vw;  \n\n     & > div {\n        max-width: 90%;\n        margin: 1.5rem auto;\n        p {\n            text-align: justify;\n            font-size: 1.5rem;\n         }  \n\n         h2 {\n            font-size: 2rem;\n            text-align: center;\n         }\n\n     }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `styles_contentContainer__fAXaI`
};
export default ___CSS_LOADER_EXPORT___;
